module.exports = __webpack_public_path__ + "static/p07_sombraBorregos-2102e10804a410f9ad05b4dabdef0e84.png";